import { render, staticRenderFns } from "./GridHoverCard.vue?vue&type=template&id=635df2df&scoped=true&"
import script from "./GridHoverCard.vue?vue&type=script&lang=js&"
export * from "./GridHoverCard.vue?vue&type=script&lang=js&"
import style0 from "./GridHoverCard.vue?vue&type=style&index=0&id=635df2df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635df2df",
  null
  
)

export default component.exports